import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Col, Modal, Row } from 'react-bootstrap-5';
import find from 'lodash/find';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import AssociatedContactSelector from 'components/tasks/associated_contact_selector';
import ContactPeopleForm from 'components/contacts/people/form';
import contactRolePropTypes from 'bundles/project/prop_types/contact_roles';
import ManagedInput from 'components/form/managed_input';

export default class InlineContactRelationForm extends React.Component {
  static propTypes = {
    availableDatabaseOptions: PropTypes.array.isRequired,
    contact: PropTypes.shape({
      contactId: PropTypes.number,
      contactName: PropTypes.string,
      contactType: PropTypes.string
    }),
    contactRoles: contactRolePropTypes.isRequired,
    onContactUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  }

  state = {
    showCreateContactForm: false
  }

  showCreateContactForm = () => {
    this.setState({ showCreateContactForm: true });
  };

  hideCreateContactForm = () => {
    this.setState({ showCreateContactForm: false });
  };

  handleCreateContact = (contact) => {
    this.props.onContactUpdate({
      contactId: contact.associatedModelId,
      contactName: contact.label,
      contactType: contact.associatedModelType
    });
    this.hideCreateContactForm();
  }

  contactModelChanged = (contactInfo) => {
    this.props.onContactUpdate({
      contactId: contactInfo.associatedModelId,
      contactType: contactInfo.associatedModelType,
      contactName: contactInfo.name
    });
  };

  selectedContact = () => {
    return ({
      associated_model_id: this.props.contact.contactId,
      associated_model_type: this.props.contact.contactType,
      name: this.props.contact.contactName
    });
  }

  renderCreateContactForm() {
    return (
      <Modal
        className="contact-modal overflow-visible"
        show={this.state.showCreateContactForm}
        onHide={this.hideCreateContactForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create a Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContactPeopleForm
            availableDatabaseOptions={this.props.availableDatabaseOptions}
            onCancel={this.hideCreateContactForm}
            onSave={this.handleCreateContact}
          />
        </Modal.Body>
      </Modal>
    );
  }

  renderForm() {
    const contact = this.props.contact;

    return (
      <div className="border my-4 p-2" name="inline-contact-selector-row">
        <Row className="align-items-end">
          <Col className="form-group required" sm={3} xs={6}>
            <label>Contact</label>
            <AssociatedContactSelector
              autoFocus
              selectedValue={this.selectedContact()}
              onCreateContact={this.showCreateContactForm}
              onHideCreateContact={this.hideCreateContactForm}
              onModelAdded={this.contactModelChanged}
            />
          </Col>

          <Col className="form-group required" sm={3} xs={6}>
            <label>Relationship</label>
            <Select
              name='role-select'
              options={this.props.contactRoles}
              value={find(this.props.contactRoles, r => r.value === contact.relationship)}
              onChange={newVal => this.props.onContactUpdate({ relationship: newVal.value })}
            />
          </Col>

          <Col sm={5} xs={11}>
            <label>Duration</label>
            <Row className="gx-2 align-items-center">
              <Col xs="auto">
                <ManagedInput
                  className="form-control"
                  name="durationStart"
                  type="date"
                  value={contact.durationStart}
                  onChange={this.props.onContactUpdate}
                />
              </Col>
              <Col xs="auto">to</Col>
              <Col xs="auto">
                <ManagedInput
                  className="form-control"
                  name="durationEnd"
                  type="date"
                  value={contact.durationEnd}
                  onChange={this.props.onContactUpdate}
                />
              </Col>
            </Row>
          </Col>

          <Col>
            <div className="btn btn-ghost" name="delete-contact" onClick={this.props.onDelete}>
              <FontAwesomeIcon className="trash-icon" icon={faTrash} size="lg" />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderForm()}
        {this.renderCreateContactForm()}
      </React.Fragment>
    );
  }
}
